import { requestsReducer } from 'redux-saga-requests';
import { GET_PIPELINES } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const pipelinesReducer = requestsReducer({
  actionType: GET_PIPELINES,
  multiple: true,
  getData: (state, action) => action.payload.data,
});
